import { getFilterConfiguration } from '@services/FilterConfiguration';
import { base64Encode } from '@services/Utils';

export function getIdsFromListData(listData) {
	let productIds = [];
	listData.data.listing.elements.forEach((product, index) => {
		if (index < 3) {
			productIds.push(product.productNumber);
		}
	});
	return productIds;
}

export function getNewParams(page, query) {
	let newParams = {
		...query
	};
	if (page > 1) {
		newParams.page = page;
	} else {
		delete newParams.page;
	}
	return newParams;
}

export function getNewSortingParams(page, query, data) {

	let newParams = {
		...query,
		order: data.value
	};
	if (page > 1) {
		newParams.page = 1;
	}
	return newParams;
}

export function getNewFilterParams(page, query, attribute, data, availableFilters) {
	let queryKeys = Object.keys(query);
	let availableFilterKeys = Object.keys(availableFilters);

	let cleanQuery = {};
	queryKeys.map((filterKey) => {
		if(availableFilterKeys.indexOf(filterKey) >= 0) {
			cleanQuery[filterKey] = query[filterKey];
		}
	});

	let newParams = {
		...cleanQuery
	};

	if (page > 1) {
		newParams.page = 1;
	}

	newParams[attribute] = formatFilter(attribute, data, availableFilters);
	return newParams;
}

export function updateRouterData({ page, order, initialPage, pathname, filters, availableFilters, query={} }) {
	let routerData = {
		pathname,
		query: query
	},
	replace;

	if (!!filters && !!availableFilters) {
		routerData.query = { ...filters ? formatFilters(filters, availableFilters) : {} };
	}

	if (!!order) {
		routerData.query.order = order;
	}

	if (!!page && page !== initialPage) {
		routerData.query.page = page;
		replace = true;
	}

	return {
		routerData,
		replace
	};
}

export function paramsHash(query) {
	let paramsObject = { ...query };

	delete paramsObject.page;

	return base64Encode(JSON.stringify(paramsObject));
}

export function formatFilters(currentFilters, availableFilters) {
	let initialFilters = Object.keys(currentFilters).map(filterKey => {
		let filter = currentFilters[filterKey];
		return { key: filterKey, value: filter };
	});

	let preparedFilters = {};
	initialFilters.forEach(filter => {
		if (!filter.value) {
			return;
		}

		preparedFilters[filter.key] = formatFilter(filter.key, filter.value, availableFilters);
	});

	return preparedFilters;
}

export function formatFilter(key, value, availableFilters) {
	if (Array.isArray(value) && value.length > 0) {
		return value.join('|');
	} else if (
		typeof value === 'object'
		&& value.hasOwnProperty('min')
		&& value.hasOwnProperty('max')
    ) {
		let filter = availableFilters[key];

		if (filter && parseInt(filter.min) === value.min && parseInt(filter.max) === value.max) {
			return;
		}

		if (value.min) {
			return value.min + ',' + value.max;
		} else {
			return value;
		}
	} else {
		return value;
	}
}

export function prepareSorting(sorting) {
	return sorting.map(sort => {
		return {
			value: sort.key,
			label: sort.translated.label
		};
	});
}

export function getAllProducts(products, prodListData, pagination) {
	const productListing = prodListData.data ? prodListData.data.listing : { elements: [], limit: 48, page: 1 };
	let allProducts = [...products];

	if (productListing.page && productListing.page > pagination.initialPage) {
		allProducts.push(...prodListData.data.listing.elements);
	} else if (productListing.page && productListing.page < pagination.initialPage) {
		allProducts.unshift(...prodListData.data.listing.elements);
	} else {
		allProducts = prodListData.data.listing.elements;
	}
	return allProducts;
}

export function isPropertyKey(key, availableFilters) {
	return availableFilters?.properties?.entities.find(property => property.customFields.attributeCode === key);
}

function enrichAvailableFilters(shouldEnrich = false, availableFilters, prodListData) {
	let filterKeys = Object.keys(prodListData.data.listing.currentFilters);
	const properties = availableFilters.properties || null;
	const hasProperties = !!properties && properties.entities?.length;
	const filterConfiguration = getFilterConfiguration();
	const enabledAttributes = filterConfiguration.enabledAttributeFilters;

	if (hasProperties && shouldEnrich) {
		filterKeys = filterKeys.filter(key => key !== 'properties');
		// 1. Add properties keys to filterKeys
		properties.entities?.forEach(property => {
			const code = property?.translated?.customFields?.attributeCode;

			if(code) {
				filterKeys.push(code);

				if (!enabledAttributes.find(f => f === code)) {
					enabledAttributes.push(property.translated?.customFields.attributeCode);
				}

				if (!availableFilters[code]) {
					availableFilters[code] = {
						name: property.translated?.customFields.attributeCode,
						label: property.translated.name,
						entities: property.options,
						isProperty: true
					};
				}
			}
		});
	}

	return filterKeys;
}

export function prepareFilters(availableFilters, prodListData, shouldEnrich = false) {
	const filterKeys = enrichAvailableFilters(shouldEnrich, availableFilters, prodListData);
	const filters = {};

	filterKeys.forEach(filterKey => {
		let filter = availableFilters[filterKey];
		if (filter) {
			if (filter.hasOwnProperty('entities')) {
				const options = [];
				filter.entities.forEach(option => {
					options.push({
						value: encodeURIComponent(option.id),
						label: option.translated.name
					});
				});

				filters[filterKey] = {
					label: filter.label,
					key: filterKey,
					type: 'dropdown',
					options: options
				};
			} else if (filter.hasOwnProperty('min') && filter.hasOwnProperty('max')) {
				filters[filterKey] = {
					label: filter.label,
					key: filterKey,
					type: 'range',
					...filter
				};
			}
		}
	});

	return filters;
}
